import React from "react";
import { motion } from "framer-motion";
import { FaBriefcase } from "react-icons/fa";
import "../App.css";

const experiences = [
  {
    role: "Full-stack Developer",
    company: "Excellence Technologies Pvt. Ltd., Noida",
    duration: "January 2026 – March 2026",
    description: "Developing and maintaining robust web applications using modern tech stacks including React.js, Node.js, and Java. Participating in full SDLC, optimizing frontend components, and collaborating on backend API development."
  },
  {
    role: "Java with JSP – Summer Training",
    company: "Arcane Programming Infotech, Lucknow",
    duration: "July 2021 – August 2021",
    description: "Completed intensive training in Java web development. Developed a College Management System using Core Java, Servlets, JSP, and MVC architecture. Implemented relational database connectivity using JDBC."
  }
];

export default function Experience() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">Experience</h2>

      <div className="row g-4 justify-content-center">
        {experiences.map((exp, index) => (
          <div key={index} className="col-md-8">
            <div className="card-custom">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h4 className="text-main fw-bold mb-1">{exp.role}</h4>
                  <p className="text-accent mb-0">{exp.company}</p>
                </div>
                <span className="small text-dim">{exp.duration}</span>
              </div>
              <p className="text-dim mb-0 small">{exp.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
